module.exports = __webpack_public_path__ + "img/md-reorder.8a05dea1.svg";